import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CoinService} from '../../../../../common/services/coin.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../../../../_services/auth.service';
import {Title} from '@angular/platform-browser';
import {GeneralService} from '../../../../../_services/general.service';
import {SubjectsService} from '../../../../../_services/subjects.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.css']
})
export class MarketingComponent implements OnInit, OnDestroy {

  loading = false;
  featuredCoins: any = [];
  coins: any = [];
  voteCoin: any;
  p = 1;
  successMessage: string | null | undefined;
  resendEmail$: any;
  user: any = {};
  coins$: any;
  topLimit = 50;
  newLimit = 20;
  newCoins: any = [];
  promotedVisible = true;
  topVisible = false;
  newVisible = false;
  topCoinsOrder = 'votes';
  orderChanged = true;
  newCoinsOrder = 'votes';

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    // const promoted = getElementById.
    const promotedTarget = document.getElementById('promotedTarget') as Element;
    const topTarget = document.getElementById('topTarget') as Element;
    const newTarget = document.getElementById('newTarget') as Element;
    if (this.checkVisible(promotedTarget)) {
      this.promotedVisible = true;
      this.topVisible = false;
      this.newVisible = false;
    } else if (this.checkVisible(topTarget)) {
      this.promotedVisible = false;
      this.topVisible = true;
      this.newVisible = false;
    } else if (this.checkVisible(newTarget)) {
      this.promotedVisible = false;
      this.topVisible = false;
      this.newVisible = true;
    }
  }

  constructor(
    private coinService: CoinService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    private titleService: Title,
    private generalService: GeneralService,
    private subjectsService: SubjectsService
  ) {
    this.titleService.setTitle('CoinCatapult - Launching Coins to the Moon');
  }

  ngOnInit() {
    this.user = this.authService.getUser() || {};
    const self = this;
    if (localStorage.getItem('regStatus')) {
      // this.successMessage = 'Your account has been created. Please visit your email address to activate account.';
      this.successMessage = 'Welcome to CoinCatapult! You can list or vote your favorite projects.';
      localStorage.removeItem('regStatus');
    }

    this.coins$ = this.subjectsService.coins.subscribe(function(val) {
      if (val) {
        self.parseCoins(val);
      }
    });
    this.subjectsService.getMarketingCoins.next(true);
  }

  checkVisible(elm: { getBoundingClientRect: () => any; }) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }

  pageChanged(event: number) {
    this.p = event;
  }

  isEmpty(obj: {}) {
    return Object.keys(obj).length === 0;
  }

  resendEmail() {
    this.resendEmail$ = this.authService.resendActivationEmail()
      .subscribe(
        (data: any) => {
          if (data.error_code.code == 0) {
            this.toastr.success('Success! Verify your email!');
            this.successMessage = null;
          } else {
            this.toastr.error(data.error_code.message);
          }
        },
        (error: any) => {
          this.toastr.error(error);
        });
  }


  parseCoins(coins: any) {
    this.coins = JSON.parse(JSON.stringify(coins)).filter(function(item: { status: number; }) {
      if (item.status !== 0) {
        return item;
      }
    });

    this.featuredCoins = JSON.parse(JSON.stringify(coins)).filter(function(item: { status: number; }) {
      if (item.status == 2) {
        return item;
      }
    });

    this.newCoins = JSON.parse(JSON.stringify(coins)).filter(function(item: { status: number; }) {
      if (item.status == 0) {
        return item;
      }
    });
  }

  changeOrder(value: string) {
    if (this.orderChanged) {
      const self = this;
      this.topCoinsOrder = value;
      this.orderChanged = false;
      setTimeout(() => {
        self.orderChanged = true;
      }, 300);
    }
  }

  handleEventList(event: { action: string; }, coin: { timeToVote: number; }) {
    if (event.action == 'done') {
      coin.timeToVote = 0;
    }
  }

  navigate(coin: { slug: string; }) {
    this.redirectTo('coin/' + coin.slug);
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate([uri]));
  }

  trackByIndex(index: any) {
    return index;
  }

  scrollToElement($element: any): void {
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

  topLoadMore() {
    this.topLimit += 50;
  }

  newLoadMore() {
    this.newLimit += 20;
  }

  ngOnDestroy(): void {

    if (this.coins$) {
      this.coins$.unsubscribe();
    }

    if (this.voteCoin) {
      this.voteCoin.unsubscribe();
    }

    if (this.resendEmail$) {
      this.resendEmail$.unsubscribe();
    }
  }

}
